import React from 'react';

import styles from './AIAssistantSlideout.module.scss';

type Props = Readonly<{
  isOpen: boolean;
  children: React.ReactNode;
}>;

/** Right-side dock overlay for timeline Ask AI (not used inside moment slideout). */
export function AIAssistantSlideout({ isOpen, children }: Props) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.layerRoot} data-testid="ai-assistant-slideout-layer">
      <div
        className={`${styles.overlay} ${styles.layerRootInteract}`}
        data-testid="ai-assistant-slideout-overlay"
        aria-hidden="true"
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label="AI assistant"
        data-testid="ai-assistant-slideout-panel"
        className={`${styles.panel} ${styles.layerRootInteract}`}
      >
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  );
}
